import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { AppointmentPickerPropertiesService } from '../appointment-picker-properties.service';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { provideNativeDateAdapter } from '@angular/material/core';
import { FormsModule } from '@angular/forms';

import { SelectableDate, SelectableSite, SelectableTime, UpcomingDates } from '../upcoming-dates';

@Component({
    selector: 'app-appointment-picker',
    imports: [
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule
],
    providers: [
        provideNativeDateAdapter(),
    ],
    templateUrl: './appointment-picker.component.html',
    styleUrl: './appointment-picker.component.scss'
})
export class AppointmentPickerComponent {
  hasAvailability = true
  isLoggedIn = false
  validDates: string[] = []
  upcomingDates: {[date: string]: SelectableDate} = {}
  sites: SelectableSite[] | undefined
  times: SelectableTime[] | undefined
  selectedDate: Date | null = null
  selectedSite: string | null = null
  selectedTime: string | null = null
  selectedTimeID: number | undefined
  @Input() appointmentType = ''
  @Input() city = ''
  @Output() dataChanged = new EventEmitter<any>();
  
  
  ngOnChanges(changes: SimpleChanges) {
    this.getAppointments()
    if (changes['appointmentType'] || changes['city']) {
      this.dataChanged.emit('appt changed');
      this.selectedSite = null
      this.selectedSite = null
      this.selectedTimeID = undefined
      this.appointmentPickerSharedProperties.selectedTime = undefined
      this.appointmentPickerSharedProperties.selectedSite = null
      this.appointmentPickerSharedProperties.selectedDate = null
    }
  }
  // @Input() rescheduleForm: Form

  hasAppointments(): Boolean {
    if (this.times) {
      return this.times.length > 0
    }
    return false
  }

  dateFilter = (d: Date | null): boolean => {
    const date = (d || new Date());
    const year = date.getFullYear()
    const month = (date.getMonth() + 1 + "").padStart(2,'0')
    const day = (date.getDate() + "").padStart(2,'0')
    const calendarDay = `${year}-${month}-${day}`
    // Prevent Saturday and Sunday from being selected.
    return this.validDates.includes(calendarDay)
  };
  constructor(public appointmentPickerSharedProperties: AppointmentPickerPropertiesService) {}

  ngOnInit() {
    // this.getAppointments()
    this.appointmentPickerSharedProperties.getDateObservable().subscribe( date => {
      this.selectedDate = date
      this.dateChanged(date);
    })
  }

  isResidentialAppointmentType(): boolean {
    return false
  }
  
  siteChanged(newObj: any) {
    const selectedDate = this.appointmentPickerSharedProperties.selectedDate
    const selectedSite = this.appointmentPickerSharedProperties.selectedSite
    this.dataChanged.emit('appt changed');
    if (selectedDate && selectedSite){
      const year = selectedDate.getFullYear()
      const month = (selectedDate.getMonth() + 1 + "").padStart(2,'0')
      const day = (selectedDate.getDate() + "").padStart(2,'0')
      const key = `${year}-${month}-${day}`
  
      const date: SelectableDate | null = (this.upcomingDates[key]) ?? null
      if (date)
      {
        const site = date.sites[newObj]
        this.times =  Object.entries(site.times).flatMap(([key, value], index) => {
          if (value.appointmentsAvailable > 0) {
            const time: SelectableTime = { 'time': key, 'id': value.appointmentTimeId }
            return time
          }
          return []
        })
      }
    }
  }

  timeChanged() {
    this.dataChanged.emit('appt changed');
  }

  dateChanged(newObj: any | null) {
    this.dataChanged.emit('appt changed');
    if (newObj)
    {
      const year = newObj.getFullYear()
      const month = (newObj.getMonth() + 1 + "").padStart(2,'0')
      const day = (newObj.getDate() + "").padStart(2,'0')
      const key = `${year}-${month}-${day}`
  
      const date: SelectableDate | null = (this.upcomingDates[key]) ?? null
      if (date)
      {
        this.sites =  Object.entries(date.sites).flatMap(([key, value], index) => {
          const mySite: SelectableSite = { 'title': value.siteTitle, 'id': key }
          return mySite
        })
      }
    }
    this.appointmentPickerSharedProperties.selectedSite = null
    this.selectedSite = null
    this.appointmentPickerSharedProperties.selectedTime = undefined
    this.selectedTime = null
  }

  updateSharedPicker() {
    // this.appointmentPickerSharedProperties.time = this.selectedTime
    // this.appointmentPickerSharedProperties.selectedTime = this.selectedTimeID
    // this.appointmentPickerSharedProperties.selectedDate = this.selectedDate
    // this.appointmentPickerSharedProperties.selectedSite = this.selectedSite
    this.dataChanged.emit('appt changed');
  }

  getAppointments() {
    const year = new Date().getFullYear();
    this.appointmentPickerSharedProperties.loadAllAppointments(year, this.appointmentType, this.city != ''? this.city : null)
    .subscribe( response => {
      if (response == null) {

      } else {
        this.upcomingDates = response.dates
        this.validDates = Object.keys(response.dates)
        this.hasAvailability = response.hasAvailability
        this.isLoggedIn = response.isLoggedIn
      }
    })
  }
}
